module.exports = __webpack_public_path__ + "static/img/022.b7d2ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/022.png
// module id = G/vC
// module chunks = 1